export const socialNetworkConnectionStatus = Object.freeze({
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
  NEVER_CONNECTED: "never_connected",
  BROKEN_CONNECTION: "broken_connection",
  MANUAL_CONNECTION: "manual_connection",
  INACTIVE: "inactive",
});
